(function () {
   function getEmbed() {
    return document.querySelector('shopify-forms-embed');
  }

  function getShadow() {
    var embed = getEmbed();
    if (!embed || !embed.shadowRoot) return null;
    return embed.shadowRoot;
  }
  function applyFormCss() {
    var embed = document.querySelector('shopify-forms-embed');

    if (!embed || !embed.shadowRoot) return false;

    var shadow = embed.shadowRoot;

    if (shadow.querySelector('#diboxx-form-custom-css')) return true;

    var style = document.createElement('style');
    style.id = 'diboxx-form-custom-css';

    style.textContent = `
    
      div[data-testid="app-router"] section[data-sizing="form-wrapper"] {
        max-width: 520px !important;
        width: 520px !important;
      }

      div[data-testid="app-router"] h2,
      div[data-testid="app-router"] [class*="_textHeading_"] {
        font-size: 35px !important;
        line-height: 1.1 !important;
        font-weight: 800 !important;
      }
        ._formContainerCloseButtonPosition_1q1d2_282 {
        display:none;
        }
        button[aria-haspopup="dialog"] {
  opacity: 0 !important;
  visibility: hidden !important;
  pointer-events: none !important;
}

      `;
      // div[data-testid="app-router"] input {
      //   border-radius: 0 !important;
      //   border: 1px solid #202020 !important;
      // }

      // div[data-testid="app-router"] button[type="submit"] {
      //   border-radius: 0 !important;
      //   background: #202020 !important;
      //   color: #ffffff !important;
      // }

    shadow.appendChild(style);
    return true;
  }

 function openShopifyForm() {
    var shadow = getShadow();
    if (!shadow) return false;

    var teaserButton = shadow.querySelector('button[aria-haspopup="dialog"]');
    if (!teaserButton) return false;

    teaserButton.click();
    return true;
  }

  function connectBodyClick() {
    if (document.body.dataset.shopifyFormBodyClick === 'true') return true;

    document.body.dataset.shopifyFormBodyClick = 'true';
    document.body.style.cursor = 'pointer';

    document.body.addEventListener('click', function (event) {
      // Do not reopen when clicking inside Shopify form
      if (event.target.closest('shopify-forms-embed')) return;

      openShopifyForm();
    });

    return true;
  }

  function init() {
    applyFormCss();
    connectBodyClick();
  }

  init();

  var observer = new MutationObserver(function () {
    init();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();